<svg
  width="25"
  height="26"
  viewBox="0 0 25 26"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_86_5684)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.32654 17.0913C7.84329 17.0913 7.45154 16.6996 7.45154 16.2163L7.45154 9.78366C7.45154 9.30041 7.84329 8.90866 8.32654 8.90866C8.80979 8.90866 9.20154 9.30041 9.20154 9.78366L9.20154 16.2163C9.20154 16.6996 8.80979 17.0913 8.32654 17.0913ZM12.5 17.0913C12.0167 17.0913 11.625 16.6996 11.625 16.2163L11.625 9.78366C11.625 9.30041 12.0167 8.90866 12.5 8.90866C12.9832 8.90866 13.375 9.30041 13.375 9.78366L13.375 16.2163C13.375 16.6996 12.9832 17.0913 12.5 17.0913ZM15.7984 16.2163C15.7984 16.6996 16.1902 17.0913 16.6734 17.0913C17.1567 17.0913 17.5484 16.6996 17.5484 16.2163L17.5484 9.78366C17.5484 9.30041 17.1567 8.90866 16.6734 8.90866C16.1902 8.90866 15.7984 9.30041 15.7984 9.78366L15.7984 16.2163Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_86_5684">
      <rect width="25" height="25" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
